import React from 'react';

import { getImageData } from 'lib/get-image-data';
import Image from 'lib/image-container';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';
import useScrollbarWidth from 'lib/use-scrollbar-width';

const PAGE_PADDING_SMALL = '16px';
const PAGE_PADDING_MEDIUM = '64px';
const PAGE_PADDING_LARGE = '108px';
const COLUMNS_GAP_MEDIUM = '32px';
const IMAGE_MAX_WIDTH_1 = '561px';

type ImageCardProps = {
    image: {
        imageId: number;
        src: string;
        hasLoadPriority?: boolean;
    };
};

export const ImageCard: React.FC<ImageCardProps> = ({ image }) => {
    const scrollbarWidth = useScrollbarWidth(true);
    const blurDataUrl = getImageData(image.src).blurDataUrl;

    const isMobile = useMediaQuery(MediaQueryWidth['desktop-sm']);

    // Calculate image widths

    let width = 321;
    let height = 416;

    if (image.imageId === 2) {
        width = 396;
        height = 512;
    }

    if (isMobile) {
        width = 170.74;
        height = 221.28;
    }

    if (isMobile && image.imageId === 2) {
        width = 210.64;
        height = 272.34;
    }

    return (
        <div className="image-card__container">
            <Image
                priority={image.hasLoadPriority}
                width={width}
                height={height}
                style={{
                    objectFit: 'cover',
                    objectPosition: '33% 31%',
                    borderRadius: '24px',
                }}
                quality={75}
                src={image.src}
                alt=""
                placeholder={blurDataUrl ? 'blur' : undefined}
                blurDataURL={blurDataUrl}
                sizes={`
    (max-width: ${MediaQueryWidth['desktop-sm']}px) calc(100vw - 2 * ${PAGE_PADDING_SMALL} - ${scrollbarWidth}),
    (max-width: ${MediaQueryWidth['tablet-lg']}px) calc((100vw - 2 * ${PAGE_PADDING_MEDIUM} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
    (max-width: ${MediaQueryWidth['content-max']}px) calc((100vw - 2 * ${PAGE_PADDING_LARGE} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
    ${IMAGE_MAX_WIDTH_1}
`}
            />
        </div>
    );
};
